var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"header"},_vm._l((_vm.titleDatas),function(item,index){return _c('div',{key:index,class:_vm.is_status == index ? 'btn btnCurrent' : 'btn',on:{"click":function($event){return _vm.go(index)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0),_c('div',{staticClass:"bottom"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }